import { Free } from "@/components/forms/MonthlyCostField.tsx";
import { PriceWithDiscount } from "@/components/PriceWithDiscount.tsx";
import type { Price } from "@/modules/pricing/resourcePricing.ts";

interface EstimatedMonthlyCostRangeProps {
    minimum: Price;
    maximum: Price;
    billingAccountId?: number;
}

export function EstimatedMonthlyCostRange({ minimum, maximum, billingAccountId }: EstimatedMonthlyCostRangeProps) {
    if (!minimum.hourly && !maximum.hourly) {
        return Free;
    }

    return (
        <>
            <PriceWithDiscount price={minimum} billingAccountId={billingAccountId} allowFree={false} />
            {" - "}
            <PriceWithDiscount price={maximum} billingAccountId={billingAccountId} allowFree={false} />
        </>
    );
}
